import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
// Models
import { FindingType } from './../../shared/models/finding-type.model';
// Providers
import { FindingService } from '../../shared/services/finding.service';

@Injectable()
export class FindingTypesResolve implements Resolve<any> {
  constructor(
    private translateService: TranslateService,
    private notificationsService: NotificationsService,
    private findingService: FindingService
  ) { }

  resolve (route: ActivatedRouteSnapshot): Promise<Array<FindingType>> {
    return this.findingService.getFindingTypes()
      .catch(error => {
        this.fetchErrorTranslation()
          .then((translation: any) => {
            this.notificationsService.error(translation.title, translation.text);
          });
        return [];
      });
  }

  fetchErrorTranslation(): Promise<any> {
    return this.translateService.get([
      'GLOBAL.ERROR.CONNECTION',
      'ADMIN_SETTINGS.FINDING_TYPES.ERROR.LOAD_FINDING_TYPES'
    ])
      .toPromise()
      .then((translation: Array<string>) => {
        return {
          title: translation['GLOBAL.ERROR.CONNECTION'],
          text: translation['ADMIN_SETTINGS.FINDING_TYPES.ERROR.LOAD_FINDING_TYPES']
        };
      });
  }
}
